<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>

<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading> -->
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
      <ContentLoader v-if="!dorms">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />
        
        <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />        
      </ContentLoader>       
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'CityGender',
  components: {
    MovieList,
    FixedPopup,
    InfiniteLoading,
    ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  data () {
    return {
      genre: '',
      url: '',
      page: 2,
      dorms: null,
      errors: [],
      gender: '',
      typeID: null,
      popupDorms: null,
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Hollywood Movies, drama movies, crime movies, horror movies, celebrities!'
      }
    }
  },
  methods: {
    infiniteHandler ($state) {
      this.checkGender()
      let self = this
      this.genre = window.localStorage.getItem('genre')
      axios
        .get(`/3/discover/${self.typeID}?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=${this.genre}&page=${this.page}`)
        .then(response => {
          if (response.data.results) {
            self.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (response.data.results.length !== 0) {
              response.data.results.forEach(item => {
                self.dorms.push(item)
              })
             // self.popupDorms = response.data.data.popups
              $state.loaded()
            } else {
              $state.complete()
            }
          }
        })
    },
    checkGender () {
      const type = this.$attrs.redirect ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Movies'
        this.typeID = 'tv'
      } else if (type && type.includes('kiz')) {
        this.gender = 'TV Shows'
        this.typeID = 'movie'
      }
    },
    getMovies () {
      this.checkGender()
      let self = this
      this.genre = window.localStorage.getItem('genre')
      axios.get(`/3/discover/${self.typeID}?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=${this.genre}&page=1`)
        .then(response => {
          // self.pagination = response.data.data
          self.dorms = response.data.results
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['cityDetails']),
    pageTitle () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_title
        else if (this.typeID === 2) title = this.cityDetails.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_description
        else if (this.typeID === 2) title = this.cityDetails.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_keywords
        else if (this.typeID === 2) title = this.cityDetails.female_keywords
      }
      return title
    }
  },
  mounted () {
    this.getMovies()
  },
  watch: {
    $route () {
      this.checkGender()
      this.getMovies()
      this.url = window.location.origin + this.$route.fullPath
    }
  },
  created() {
    this.getMovies()
    this.url = window.location.origin + this.$route.fullPath
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/city";
  @import "../../assets/scss/components/pagination-new";

  /*.info-card {*/
    /*height: auto !important;*/
  /*}*/

  .wrapper {
    padding-bottom: 170px;
  }

  .dorm-tab__header {
    margin-top: -90px;
  }

  .select__title {
    font-size: 17px !important;
  }
  .city-text p {
    color: #fff !important;
  }
</style>
